// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"b1e79bbd","723":"d80655e8"}[chunkId] + ".chunk.css";
};